import { SkeletonBlock } from "components/general/Skeleton";
import { useMemo } from "react";
import { GlobalStore } from "store/global/GlobalStore";
import { ReactComponent as GenericWallet1 } from "../img/wallets/generic/generic-wallet-1.svg";
import { ReactComponent as GenericWallet10 } from "../img/wallets/generic/generic-wallet-10.svg";
import { ReactComponent as GenericWallet11 } from "../img/wallets/generic/generic-wallet-11.svg";
import { ReactComponent as GenericWallet2 } from "../img/wallets/generic/generic-wallet-2.svg";
import { ReactComponent as GenericWallet3 } from "../img/wallets/generic/generic-wallet-3.svg";
import { ReactComponent as GenericWallet4 } from "../img/wallets/generic/generic-wallet-4.svg";
import { ReactComponent as GenericWallet5 } from "../img/wallets/generic/generic-wallet-5.svg";
import { ReactComponent as GenericWallet6 } from "../img/wallets/generic/generic-wallet-6.svg";
import { ReactComponent as GenericWallet7 } from "../img/wallets/generic/generic-wallet-7.svg";
import { ReactComponent as GenericWallet8 } from "../img/wallets/generic/generic-wallet-8.svg";
import { ReactComponent as GenericWallet9 } from "../img/wallets/generic/generic-wallet-9.svg";

const genericWalletIcons = [
  GenericWallet1,
  GenericWallet2,
  GenericWallet3,
  GenericWallet4,
  GenericWallet5,
  GenericWallet6,
  GenericWallet7,
  GenericWallet8,
  GenericWallet9,
  GenericWallet10,
  GenericWallet11,
];

export const useGenericWalletIcon = () => {
  const address = GlobalStore.useState(s => s.address);
  const localStorageKey = `${address}:genericWalletIconIdx`;

  const selectedIdx = useMemo(() => {
    if (address === "") return null;
    const localStorageValue = window.localStorage.getItem(localStorageKey);
    const localStorageValueNum = Number(localStorageValue);

    if (localStorageValue != null && !isNaN(localStorageValueNum)) {
      return localStorageValueNum;
    }

    const selectedIdx = Math.floor(Math.random() * genericWalletIcons.length);
    window.localStorage.setItem(localStorageKey, String(selectedIdx));
    return selectedIdx;
  }, [address, localStorageKey]);

  const SelectedIcon = selectedIdx == null ? SkeletonBlock : genericWalletIcons[selectedIdx];
  return SelectedIcon;
};
